/**
 * The loyalty provider.
 * @enum {number}
 */
export enum LoyaltyProvider {
    NONE = 0,
    ADORA = 1,
    PUNCHH = 4
}

export enum MapProvider {
    NONE = 0,
    GOOGLE = 1,
    HERE = 2,
    MAPBOX = 3
}

export enum CustomerProviderEnum {
    NONE = 0,
    ADORA = 1,
    PUNCHH = 4
}

/**
 * The type of loyalty program.
 * @enum {number}
 */
export enum LoyaltyProgramType {
    REWARDS = 1,
    REDEEM_POINTS = 2,
    MEMBERSHIP = 3
};

/**
 * The type of form field.
 * @enum {string}
 */
export enum FieldType {
    PHONE = 0,
    EMAIL = 1,
    DAY = 2,
    MONTH = 3,
    NAME = 4,
    ZIP = 5,
    PASSWORD = 6,
    COMPAREPASSWORDS = 7,
    OLDPASSWORD = 8,
    BOOLEAN = 9,
    CUSTOM = 10,
    CAR = 11,
    FAILED = 12,
    TIP = 13,
    CREDIT_CARD_NUMBER = 14,
    CREDIT_CARD_EXP = 15,
    CREDIT_CARD_CVV = 17,
    CREDIT_CARD_ADDRESS = 18,
    CREDIT_CARD_ZIP = 19,
    CHECKED = 20,
    CREDIT_CARD_CVV_SIMPLE = 21,
    GIFT_CARD_NUMBER = 22,
    GIFT_CARD_PIN = 23,
    REQUIRED = 24,
    GIFT_CARD_PIN_VALUTEC = 25
};

export enum LoggedInStatus {
    ANONYMOUS = 0,
    EXTERNAL = 1,
    LOGGEDIN = 2
};

export enum CardBrand {
    VISA = 1,
    MASTERCARD = 2,
    AMEX = 3,
    DISCOVER = 4,
    DINERSCLUB = 5,
    JCB = 6,
    DINERS = 7,
    UNKNOWN = 0
}

export enum OrderType {
    DINE_IN = 1,
    TAKE_OUT = 2,
    DELIVERY = 3
}

export enum MerchantProcessor {
    Mercury = 1,
    Valutec = 2,
    Adora = 3,
    Heartland = 4,
    LevelUp = 5,
    MX = 6,
    SmartTransactions = 7,
    WorldPayTriPOS = 8,
    Elavon = 9,
    OpenPay = 10,
    O2GPay = 11,
}

export enum WalletType {
    None = 0,
    GooglePay = 1,
    ApplePay = 2,
    ApplePayApp = 3,
    ApplePayWeb = 4,
    GooglePayApp = 5,
    GooglePayWeb = 6,
    SamsungWallet = 7
}

export enum ItemStyle {
    VERTICAL_SIZE_BTN = 1,
    VERTICAL_OPTIONS = 2,
    HORIZONTAL_IMAGE_LEFT = 3,
    HORIZONTAL_IMAGE_RIGHT = 4
}

export enum AddressType {
    HOUSE = 1,
    GATED_HOUSE = 2,
    APT = 3,
    BUSINESS = 4,
    SCHOOL = 5,
    HOTEL = 6,
    PARK = 7
}

export enum Curbside {
    NO = 0,
    PRINT_ONLY = 1,
    PARKING_STALLS_WITH_TEXTING = 2,
    PARKING_STALLS_WITH_EMAIL_LINK = 3,
    CUSTOMER_CAR_INFO = 4
}

export enum PaymentPaymentType {
    CREDIT_CARD_WALLET = -4,
    CASH = 1,
    CREDIT_CARD = 4,
    GIFT_CARD = 7,
    CREDIT_CARD_ON_DELIVERY = 33
}

export enum PaymentType {
    PAY_IN_STORE = 0,
    CASH = 1,
    CREDIT_CARD = 2,
    WALLET_CREDIT_CARD = 3,
    CREDIT_CARD_MOBILE = 4
}

export enum OnlinePaymentOption {
    PAY_IN_STORE = "0",
    CASH = "1",
    CREDIT_CARD = "2",
    CREDIT_CARD_UPON_DELIVERY = "3",
    CREDIT_CARD_PRE_VALIDATE = "4",
    CREDIT_CARD_WALLET = "5",
    GIFT_CARD = "6",
    APPLE_PAY = "7",
    GOOGLE_PAY = "8"
}

export enum StoreStatusId {
    ACTIVE = 1,
    TEMPORARILY_CLOSED = 2,
    CLOSED = 3,
    INACTIVE = 4,
    COMING_SOON = 5
}

export enum AddressValidation {
    INVALID = 0,
    VALID = 1,
    OUT_OF_DELIVERY_ZONE = 2,
    OUT_OF_TIME = 3,
    INVALID_NO_ZIP = 4,
    BLOCKED = 5,
    INVALID_ST_NUMBER = 6,
    INVALID_ST_NAME = 7,
    INVALID_NO_STREET_NUMBER = 8
}

export enum CouponIdList {
    MANAGER_DOLLAR_OFF = 1,
    MANAGER_PERCENT_OFF_ORDER = 2,
    MANAGER_FIXED_PRICE = 3,
    MANAGER_NEXT_ORDER_CREDIT_DOLLAR_OFF = 4,
    MANAGER_NEXT_ORDER_CREDIT_PERCENT_OFF = 5,
    MANAGER_PERCENT_OFF_ITEM = 6,
    LOYALTY_REDEEM_ITEM = 7,
    EMPLOYEE_DISCOUNT = 8,
    EMPLOYEE_CONSUMPTION = 9,
    LOYALTY_OFFER_THIRDPARTY = 10,
    LOYALTY_REWARD_THIRDPARTY = 11
}

export enum CouponLimitPerOrder {
    NO_LIMIT_207 = 0,
    ONE_PER_ORDER = 1,
    TWO_PER_ORDER = 2,
    THREE_PER_ORDER = 3,
    OVERRIDE_207 = 4
}

export enum StoreCouponLimitType { // Setting 207
    NO = 0,
    IN_STORE_ONLY = 1,
    ONLINE_ONLY = 2,
    BOTH = 3
}

export enum CouponTypeList {
    MANAGER_DISCOUNT = 1,
    NEXT_ORDER_CREDIT = 2,
    LOYALTY_DISCOUNT = 3,
    EMPLOYEE_DISCOUNT = 4,
    EMPLOYEE_CONSUMPTION = 5,
    DOLLAR_OFF = 10,
    FIXED_PRICE = 20,
    PERCENTAGE_OFF_ENTIRE_ORDER = 30,
    PERCENTAGE_OFF_AN_ITEM = 31,
    PERCENTAGE_OFF_AN_ITEM_IN_CATEGORY_OR_BOGO_IN_CATEGORY = 32,
    PERCENTAGE_OFF_ALL_ITEMS_IN_CATEGORY = 33,
    PERCENTAGE_OFF_TWO_ITEMS_IN_CATEGORY = 34,
    PERCENTAGE_OFF_ITEM_IN_CATEGORY_BASED_ON_PRICE = 35, // eg. 49% one topping pizza only
    UPGRADE = 40,
    QUANTITY_PRICE = 50,
    QUANTITY_DISCOUNT = 51,
    MIX_AND_MATCH_PRICE = 52,
    MIX_AND_MATCH_PERCENTAGE = 53
}

export enum CouponImageType {
    NONE = 0,
    THUMBNAIL = 1,
    FULL_BOX = 2
}

export enum BahamasCoordinates {
    LAT = 25.0343,
    LONG = -77.3963
}

export enum EmailTextMarketingType {
    NONE = 0,
    EMAIL_ONLY = 1,
    TEXT_ONLY = 2,
    EMAIL_AND_TEXT = 3
}

export enum AddressLookupType {
    NONE = 0,
    INTERNAL = 1,
    GOOGLE = 2
}

export enum Setting81 {
    NONE = 0,
    DESKTOP_AND_APP = 1,
    DESKTOP_ONLY = 2,
    APP_ONLY = 3
}

export enum PayInStoreAlternate {
    NONE = 0,
    CREDIT_CARD = 1,
    PRE_VALIDATED_CREDIT_CARD = 2
}
export enum CashAlternate {
    NONE = 0,
    CREDIT_CARD = 1,
    PRE_VALIDATED_CREDIT_CARD = 2
}
export enum CardOnFileCvvOption {
    IGNORE = 0,
    MUST_MATCH = 1,
    MUST_MATCH_OVER_THERSHOLD = 2
}

export enum CreditCardPreValidationOption {
    DO_NOT_VALIDATE = 0,
    VALIDATE = 1,
    VALIDATE_OVER_THERSHOLD = 2

}

export enum CreditCardAvsOption {
    DO_NOT_VALIDATE = 0,
    ADDRESS_ONLY_PROMPT_VALIDATE = 1,
    ZIP_ONLY_PROMPT_VALIDATE = 2,
    ADDRESS_OR_ZIP_MUST_MATCH = 3,
    ADDRESS_AND_ZIP_MUST_MATCH = 4,
    DO_NOT_VALIDATE_UNDER_THRESHOLD_ADDRESS_OR_ZIP_MUST_MATCH_OVER_THERSHOLD = 5,
    DO_NOT_VALIDATE_UNDER_THRESHOLD_ADDRESS_AND_ZIP_MUST_MATCH_OVER_THERSHOLD = 6,
    ADDRESS_OR_ZIP_MUST_MATCH_UNDER_THRESHOLD_ADDRESS_AND_ZIP_MUST_MATCH_OVER_THERSHOLD = 7
}

export enum CreditCardCvvOption {
    IGNORE = 0,
    MUST_MATCH = 1,
    MUST_MATCH_OVER_THERSHOLD = 2
}
export enum CreditCardOption {
    CHARGE = 1,
    PRE_VALIDATED = 2,
    CHARGE_UPON_DELIVERY = 3
}

export enum Pages {
    LANDING = "/",
    LOCATIONS = "/locations",
    REWARDS = "/rewards",
    FAVORITES = "/favorites",
    MENU = "/menu",
    MENU_VIEW_ALL = "/menu_view_all",
    ORDERS = "/orders",
    TRACK_ORDER = "/track_order",
    //SETTINGS = "/settings",
    ACCOUNT = "/account",
    TERMS = "/terms",
    CART = "/cart",
    CHECKOUT = "/checkout",
    CURBSIDE = "/curbside",
    UNSUBSCRIBE = "/unsubscribe"
}

export enum Modals {
    LOGIN = "login",
    SIGNUP = "signup",
    HAMBURGER = "hamburger",
    CUSTOMIZE_ITEM = "customize_item",
    CONFIRMATION = "confirmation",
    ACCOUNT_CONTACT = "account_contact",
    ACCOUNT_CHANGE_PASSWORD = "account_change_password",
    ACCOUNT_CONFIRM_DELETE = "account_confirm_delete",
    MEAL_DEAL = "meal_deal",
    LOCATION_SELECTOR = "location_selector",
    FUNDRAISER = "fundraiser",
    HEADER_ACCOUNT = "header_account",
    CHALLENGES = "challenges",
    SELECT_SECOND_HALF = "select_second_half",
    REWARD_GROUP_ITEMS = "reward_group_items",
    STORE_SELECTOR = "store_selector",
    ORDER_TYPE_AND_TIME = "order_type_and_time",
}

export enum CalorieDisplay {
    SERVING = 1,
    FRACTION = 2
}

export enum HalfModifierSelection {
    LEFT = 0,
    WHOLE = 1,
    RIGHT = 2
}

export enum TimeSelection {
    ASAP = 0,
    LATER = 1
}

/**
* The type of order process status.
* @enum {number}
*/
export enum OrderStatus {
    Received = 1,
    Making = 2,
    Cooking = 3,
    Ready = 4,
    BeingDelivered = 5,
    OrderArriving = 13,
    Delivered = 6
}

export enum CheckoutMethodType {
    IN_STORE = 0,
    CURBSIDE = 1
}

export enum ChallengeFieldType {
    CHECKBOX = 1,
    OPEN_FIELD = 2
}

export enum CookiePreferences {
    ACCEPT = "accept",
    REJECT = "reject"
}

export enum PlatformType {
    DESKTOP = "Desktop",
    IOS = "Ios",
    ANDROID = "Android"
}

export enum LoginStatus {
    LOGGEDIN = "logged_in",
    LOGGEDOUT = "logged_out",
}

export enum HttpStatusCode {
    OK = 200,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    REQUEST_TIMEOUT = 408,
    TOO_MANY_REQUESTS = 429
}

export enum MenuLocationType {
    HEADER = "Header",
    FOOTER = "Footer"
}

export enum RewardType {
    OFFER = "Offer",
    POINTS = "Points"
}

export enum ContentType {
    USER_PROFILE = "user_profile",
    LOCATION = "location",
    MENU_ITEM = "menu_item",
    OFFER = "offer",
    POINTS = "points",
    CALL = "call"
}

export enum CarryOutType {
    NOT_APPLICABLE = "not_applicable",
    IN_STORE = "in_store"
}

export enum ToppingType {
    MEAT = "meat",
    VEG = "veg",
    CHEESE = "cheese",
    CRUST = "crust",
    SAUCE = "sauce"
}

export enum OrderNotificationType {
    NONE = "None",
    PHONE = "Text",
    EMAIL = "Email",
}

export enum StoreListType {
    FAVORITES = "favorites",
    NEARBY = "nearby",
}

export enum BirthdayRequirement {
    DO_NOT_SHOW = 0,
    OPTIONAL = 1,
    REQUIRED = 2
}

export enum DataLayerErrorType {
    USER_ERROR = "user_error",
    CONSOLE_ERROR = "console_error",
}

export enum DataLayerPromotionLocation {
    LANDING_BANNER = "Homepage Promotion",
    MEAL_DEAL = "Hot Deals"
}

export enum CustomizeItemUiOption {
    SINGLE_ITEM = 0,
    MULTI_ITEM = 1
}

export enum MealDealLocationUiOption {
    MEAL_DEAL_AS_TAB = 0,
    MEAL_DEAL_AS_MENU_CATEGORY = 1
}

export enum AppPlatform {
    ANDROID = "android",
    IOS = "ios"
}

export enum Country {
    UNITED_STATES = 1,
    MEXICO = 2,
    BAHAMAS = 4
}

export enum AutocompleteProvider {
    NONE = -1,
    GOOGLE = 0,
    ADORA = 1,
    HERE = 2,
    MAPBOX = 3
}

export enum DeliveryProvider {
    NONE = 0,
    DOORDASH_DRIVE = 1,
    SHIPDAY = 2
}

export enum RoundingRule {
    DO_NOT_ROUND = 0,
    ROUND_DOWN = 1,
    ROUND_UP = 2,
    ROUND_TO_NEAREST = 3
}